import React, { Component } from 'react';

import { CtExamHeader, CtExamLeakFileList } from 'containers';

class CtExamLeakFile extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { currentPath } = this.props;

    return (
      <div className="exam-wrapper">
        <CtExamHeader />
        <div className="exam-leak-file-area">
          <CtExamLeakFileList />
        </div>
      </div>
    );
  }
}

export default CtExamLeakFile;



// WEBPACK FOOTER //
// ./src/script/containers/exam/CtExamLeakFile.js